import React from "react";
import CustomizedAccordions from './accordion.jsx'
export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Our Services</h2>
        </div>
        <CustomizedAccordions/>    
      </div>
    </div>
  );
};
